import { render, staticRenderFns } from "./post-view.vue?vue&type=template&id=5a810624&scoped=true&"
import script from "./post-view.vue?vue&type=script&lang=js&"
export * from "./post-view.vue?vue&type=script&lang=js&"
import style0 from "./post-view.vue?vue&type=style&index=0&id=5a810624&lang=css&scoped=true&"
import style1 from "./post-view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a810624",
  null
  
)

export default component.exports